import { number, partial } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

import { VolumetricMeasurableItem } from './VolumetricMeasurableItem';

export const Type = partial({
	total: VolumetricMeasurableItem,
	uniqueTrussTypes: iotsUtils.makePartialRecordDecoder(
		constants.job.volumetrics.measurableIds,
		number
	),
});
